var $ = require('jQuery');
var _ = require('underscore');
var tectoastr = require('tectoastr');

module.exports = function (data) {
    var container = $('#funding-panel');
    var addButton = $('.funding-add');
    var saveButton = $('.funding-save');
    var totals = $('#funding-totals');
    var table = container.find('table');
    var tbody = container.find('tbody');
    var template = $('#allocation-template');

    var active = null;

    var newRow = function () {
        active = template.clone()
            .removeAttr('id')
            .removeAttr('hidden')
            .appendTo(tbody);

        return active;
    };

    var refresh = function () {
        var hasAllocations = ! _.isEmpty(data.allocations);

        addButton.show();
        saveButton.hide();
        totals.html(data.totals);
        tbody.empty();

        $('.funding-hide-empty').toggle(hasAllocations);
        $('.funding-show-empty').toggle(!hasAllocations);

        if (!hasAllocations) {
            return;
        }

        var fundSelector = $('.allocation-name .form-control')
        fundSelector.empty();

        _.each(data.funds, function (value, key) {
            fundSelector.append('<option value=' + key.replace('id-','') + '>' + value + '</option>');
        });

        _.each(data.allocations, function (allocation) {
            var row = newRow();
            row.data('allocation', allocation.id);
            row.find('.form-control').hide();
            row.find('.allocation-name span').text(allocation.name);
            row.find('.allocation-name .form-control').val(allocation.fundId);
            row.find('.allocation-amount span').html(allocation.amount);
            row.find('.allocation-amount .form-control').val(allocation.rawAmount);
        });
    };

    var showAddRow = function () {
        addButton.hide();
        saveButton.show();
        table.show();

        newRow().find('.overflow-cell').hide();
    };

    var handleDone = function (response) {
        data.allocations = response.allocations;
        data.totals = response.totals;
        data.funds = response.funds;

        refresh();
    };

    var handleFail = function (response) {
        if (response.status == 422) {
            tectoastr.error(_.flatten(_.values(response.responseJSON)).join(' '));
        } else {
            tectoastr.error(data.messages.error);
        }
    };

    var editAllocation = function (event) {
        event.preventDefault();

        addButton.hide();
        saveButton.show();

        if (active && !active.data('allocation')) {
            active.remove();
        } else if (active) {
            active.find('.allocation-name span, .allocation-amount span').show();
            active.find('.form-control').hide();
        }

        active = $(this).closest('.funding-allocation');
        active.find('.allocation-name span, .allocation-amount span').hide();
        active.find('.form-control').show();
    };

    var saveAllocation = function () {
        var fund = active.find('[name=fund]').val();
        var amount = active.find('[name=amount]').val();

        if (!fund || !amount) {
            return refresh();
        }

        saveButton.prop('disabled', true);

        var allocation = active.data('allocation');

        $.ajax({
                method: 'POST',
                url: allocation ? data.routes.update : data.routes.add,
                dataType: 'json',
                data: {
                    '_method': allocation ? 'PUT' : 'POST',
                    allocation: allocation,
                    fund: fund,
                    amount: amount
                }
            })
            .done(handleDone)
            .fail(handleFail)
            .always(function () {
                saveButton.prop('disabled', false);
            });
    };

    var deleteAllocation = function (event) {
        event.preventDefault();

        $.ajax({
            method: 'POST',
            url: data.routes.delete,
            dataType: 'json',
            data: {
                '_method': 'DELETE',
                selected: [$(this).closest('.funding-allocation').data('allocation')]
            }
        })
            .done(handleDone)
            .fail(handleFail);
    };

    refresh();

    addButton.on('click', showAddRow);
    saveButton.on('click', saveAllocation);
    container.on('click', '.allocation-delete', deleteAllocation);
    container.on('click', '.allocation-edit', editAllocation);
    container.on('keypress', '.allocation-amount input', function (event) {
        // Check it was 'enter' (magic number 13)
        if (event.which == 13) saveAllocation();
    });
};
